import { graphql } from 'babel-plugin-relay/macro';
import { get } from 'lodash';
import { call, takeLatest } from 'redux-saga/effects';
import { commitLocalUpdate, fetchQuery } from 'relay-runtime';
import { createAsyncAction, getType } from 'typesafe-actions';
import { LoggerStatusEnum, sendLog } from 'ui-model';

import environment from '@lib/utils/RelayEnvironment';

import { SAVE_PATIENT_SUCCESS } from 'containers/PatientPage/constants';
import { invalidateRecord, toGlobalId } from 'services/relayService';

import sagaRelayInvalidateData from './sagaRelayInvalidateData';

export const actionPatientCreate = createAsyncAction(
  'actionPatientCreate/REQUEST',
  'actionPatientCreate/SUCCESS',
  'actionPatientCreate/FAILURE',
)<any, any, any>();

const query = graphql`
  query sagaWatchersPatientQuery($id: MongoID!) {
    patientById(_id: $id) {
      ...CardPatient_Patient
      ...ListPatientContacts_Patient
    }
  }
`;

function* sagaInvalidateStore(action: any) {
  yield sagaRelayInvalidateData('Patient');

  try {
    const patient = get(action, 'data');
    if (!patient) {
      throw new Error('data missing');
    }

    let needsRefetch = false;
    commitLocalUpdate(environment, (store) => {
      try {
        const patientRecord = store.get(toGlobalId('Patient', patient._id));
        if (!patientRecord) {
          return;
        }

        // Invalidate record to mark queries as stale
        invalidateRecord(patientRecord);

        // Refetch query to update Relay store as we can't dynamically update some of the fields
        // eg patient.contact: https://github.com/facebook/relay/issues/2441
        // patientRecord.setValue(patient.contact, 'contact');
        needsRefetch = true;
      } catch (error) {
        sendLog('sagaWatchersPatient', { error, action }, LoggerStatusEnum.error);
      }
    });
    if (needsRefetch) {
      yield call(fetchQuery, environment, query, { id: patient._id });
    }
  } catch (error) {
    sendLog('sagaWatchersPatient', { error, action }, LoggerStatusEnum.error);
  }
}

export default function* sagaWatchersPatient() {
  yield takeLatest(SAVE_PATIENT_SUCCESS, sagaInvalidateStore);
  yield takeLatest(getType(actionPatientCreate.success), sagaInvalidateStore);
}
